import { Injectable } from '@angular/core';
import { AuthorizationConfig } from 'src/app/models/AuthorizationConfig';
import { UIActions } from 'src/app/models/UIActions';
import { UIRoutes } from 'src/app/models/UIRoutes';
import { UIs } from 'src/app/models/UIs';
import { User } from 'src/app/models/User';
import Store, { AppKey } from '../../store';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor() { }

  hasPermission(ui: UIs, action?: UIActions): boolean {
    const user = new Store().get(AppKey.USER) as User;
    if (user?.IsSeeded && !user.IsReadOnlyAdmin) return true;
    const role = user?.Role;
    if (!role) return false;
    const uiFound = role.UIs.find((access) => access.Name == ui);
    if (!uiFound) return false;
    if (action) {
      const actionFound = uiFound.Actions.find(
        (access) => access.Name == action
      );
      return !!actionFound;
    } else return true;
  }

  hasActionPermission(action: UIActions): boolean {
    const user = new Store().get(AppKey.USER) as User;
    if (user?.IsSeeded && !user.IsReadOnlyAdmin) return true;
    const role = user?.Role;
    if (!role) return false;
    if (action) {
      const actionFound = role.UIs.flatMap(({ Actions }) => Actions).find(
        (access) => access.Name == action
      );
      return !!actionFound;
    } else return false;
  }

  canAccessRoute(route: UIRoutes): boolean {
    if (route == 'home')
      return true;
    const user = new Store().get(AppKey.USER) as User;
    if (user?.IsSeeded && !user.IsReadOnlyAdmin) return true;
    const role = user?.Role;
    if (!role) return false;
    const ui = AuthorizationConfig.get().find(({ Route }) => route === Route);

    const excludeFromRoleCheck = [UIRoutes.Integration];
    if (excludeFromRoleCheck.includes(route)) return true;

    // TODO: return false below when all routes have been handled, this is currently a relaxed condition.
    if (!ui) return false;
    const uiIsOnRole = role.UIs.find((access) => access.Name == ui.Name);
    return !!uiIsOnRole;
  }
}
